import { z } from 'zod';

// One registered «Usuario» a carrier may not reserve for, on
// `GET /app_service/panel/v1/exclusion-lists/<slug>/users/`, mirrored from the delivered shape.
//
// Tolerant, not `.strict()`: this read renders its rows, so an additive field is inert. The
// strictness of the door-access count envelope exists because that one counts `.length`; it must
// not be copied here.
//
// `since` stays a string: app-service runs `USE_TZ = False`, so it is a naive ISO-8601 whose
// instant is UTC by convention. The screen decides the zone it renders in; a `Date` here would let
// the browser decide instead.
export const ExcludedUserSchema = z
  .object({
    user_id: z.number().int().positive(),
    name: z.string(),
    phone: z.string(),
    since: z.string(),
  })
  .transform(({ user_id, name, phone, since }) => ({ userId: user_id, name, phone, since }));

export type ExcludedUser = z.infer<typeof ExcludedUserSchema>;

export const ExclusionListUsersSchema = z.object({ users: z.array(ExcludedUserSchema) });

export type ExclusionListUsers = z.infer<typeof ExclusionListUsersSchema>;
